import React, { useEffect } from 'react'
import HomeContainer from '../containers/Home'
import Nav from '../components/nav/Nav';


const HomePage: React.FC= () => {

  useEffect(() => {
    document.title = 'Elite Community Credit Union';

    const metaDescription = document.createElement('meta');
    metaDescription.name = 'description';
    metaDescription.content = 'Elite Community Credit Union secure and reliable banking for all your needs. Get competitive rates, manage your finances on the go, and experience exceptional customer service. Open an account today';
    document.head.appendChild(metaDescription);
  }, []);


  return (
    <div>
      <Nav />
      <HomeContainer />
    </div>
  )
}

export default HomePage
